<!-- this component contains the information of thr water calculator with formula used in calculator -->
<template>
  <div class="mt-3">
    <h2>STAYING HYDRATED</h2>
    <p>
      We have signals from our bodies that tell us when to drink: dry mouth, the
      feeling of thirst we are all familiar with, heavily coloured urine… we all
      know the symptoms. However, when we feel thirsty or notice any of these
      symptoms, we are usually already dehydrated. In fact, by the time you feel
      thirsty, your body may already be down 1% of its natural water balance.
      Even 1% can have a drastic effect on health, energy levels and athletic
      performance.
    </p>
    <p>Drinking when you’re thirsty isn’t a particularly viable option.</p>
    <p>
      Keeping hydrated is one of the simplest yet most important ways in which
      you can maintain optimum health and fitness. The human body is made up of
      around 60% water; our organs and cells need water to function properly,
      and correct blood volume and circulation relies heavily on adequate
      hydration.
    </p>
    <p>
      For some perspective, we can see that the heart and brain are made up of
      73% water; the muscles and kidneys about 79%; the lungs about 83%; skin is
      around 64%; and the bones 31%.
    </p>
    <p>
      Taking in the right amount of water on a daily basis- at regular
      intervals- is essential. Without doing so, the human body cannot allot
      water correctly to cells and organs. It will have to prioritise where the
      scarce volume of water it is taking in goes, leaving many bodily processes
      working sub-par.
    </p>
    <h2 class="mt-5">HOW MUCH WATER SHOULD YOU DRINK PER DAY?</h2>
    <p>
      Water intake in a day can vary a great deal. As your body requires water
      for the proper functioning of the vital organs, along with many bodily
      processes, we need to get this amount right. Drinking any less can lead to
      many of the health complications mentioned above.
    </p>
    <p>
      Obviously, you want to be drinking enough water every day to keep your
      body hydrated. If in doubt, go for more rather than less. If you find
      yourself running to the bathroom every half hour, you’ll have over done
      it. However, aside from frequent toilet trips, there are few downsides to
      drinking too much: any excess water is simply flushed away as waste.
    </p>
    <p>
      8 large glasses per day is often bandied about as a good number. This may
      be a good starting point- it will certainly be more than many people drink
      as a matter of course. However, it still may not be enough. If you tend to
      sweat heavily, lead an active lifestyle, live in a hot climate, or have
      any other health or lifestyle factors that mean you grow easily
      dehydrated, you will need more than this.
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
